import { timezoneDate } from 'utils/helpers'

export const fromProposals = proposals => {
  const proposalFormat = []
  for (let i = 0; i < proposals.length; i++) {
    proposalFormat.push({
      id: proposals[i].id,
      dealId: proposals[i].deal.id,
      dealName: proposals[i].deal.name,
      companyId: proposals[i].company.id,
      companyName: proposals[i].company.name,
      dealDueDate: timezoneDate(proposals[i].deal.dueDate)
    })
  }
  proposalFormat.sort((a, b) => new Date(a.dealDueDate) - new Date(b.dealDueDate))
  return proposalFormat
}
